interface FeatureTagProps {
  children: React.ReactNode;
}

export function FeatureTag({ children }: FeatureTagProps) {
  return (
    <span className="rounded-[100px] bg-white px-4 py-1.5 text-[16px] leading-[130%] text-[#3B3B3B]/70">
      {children}
    </span>
  );
}
